var path = '/modules/contacts/views/pages/import.tpl.html';
var html = "<importer\n    ng-if=\"vm.fields\"\n    type=\"contact\"\n    import-url=\"contacts/import\"\n    fields=\"vm.fields\"\n    on-success=\"vm.onSuccess(response)\"\n    on-failure=\"vm.onFailure(response)\"\n/>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/import.tpl.html
// module id = 2082
// module chunks = 1